import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'stars',
  template: `
    <div id="stars">
      <div *ngFor="let star of stars">
        <mat-icon
          ngClass="{{ star }} {{ size }}"
          [ngStyle]="{'color': color}">
          {{ star }}
        </mat-icon>
      </div>
    </div>
  `,
  styleUrls: ['./stars.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StarsComponent implements OnInit {
  @Input() rating: number;
  @Input() size: string;
  @Input() color = 'rgb(255, 178, 0)';

  public stars = [
    'star_border',
    'star_border',
    'star_border',
    'star_border',
    'star_border'
  ];

  ngOnInit(): void {

    for (let i = 0; i < this.rating; i++) {
      this.stars[i] = 'star';
    }

    if (!Number.isInteger(this.rating)) {
      const decimalNumber = this.rating % 1;
      if (decimalNumber > 0.25){
        this.stars[this.stars.lastIndexOf('star')] = 'star_half';
      } else {
        this.stars[this.stars.lastIndexOf('star')] = 'star_border';
      }
    }
  }
}
